/**
 * @generated SignedSource<<0e232db4615c65b7d22e600990ca6fb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganisationSwitcherQuery$variables = {
  profileId: string;
};
export type OrganisationSwitcherQuery$data = {
  readonly secureToken: string;
};
export type OrganisationSwitcherQuery = {
  response: OrganisationSwitcherQuery$data;
  variables: OrganisationSwitcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "profileId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "profileId",
        "variableName": "profileId"
      }
    ],
    "kind": "ScalarField",
    "name": "secureToken",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganisationSwitcherQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganisationSwitcherQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3407dba68d75acf90d5f775cace4f532",
    "id": null,
    "metadata": {},
    "name": "OrganisationSwitcherQuery",
    "operationKind": "query",
    "text": "query OrganisationSwitcherQuery(\n  $profileId: String!\n) {\n  secureToken(profileId: $profileId)\n}\n"
  }
};
})();

(node as any).hash = "22dfb3053591cc2ed34799799773f8f9";

export default node;
